import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { ExpenseSummary } from '../../types/expense';

interface ExpenseSummaryCardsProps {
  summary: ExpenseSummary;
}

const ExpenseSummaryCards: React.FC<ExpenseSummaryCardsProps> = ({
  summary,
}) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const cardClass = isDark
    ? 'bg-slate-900/50 border border-slate-700/50 backdrop-blur-sm'
    : 'bg-white border border-slate-200 shadow-sm';

  const formatCurrency = (
    amount: number | string | null | undefined,
  ): string => {
    const numAmount = Number(amount || 0);
    return `$${numAmount.toFixed(2)}`;
  };

  const statusCards = [
    {
      status: 'draft',
      label: 'Draft',
      count: summary.status_summary.draft.count,
      amount: summary.status_summary.draft.amount,
      colorClass: isDark ? 'text-slate-400' : 'text-slate-500',
    },
    {
      status: 'pending',
      label: 'Pending',
      count: summary.status_summary.pending.count,
      amount: summary.status_summary.pending.amount,
      colorClass: 'text-amber-500',
    },
    {
      status: 'approved',
      label: 'Approved',
      count: summary.status_summary.approved.count,
      amount: summary.status_summary.approved.amount,
      colorClass: 'text-emerald-500',
    },
    {
      status: 'rejected',
      label: 'Rejected',
      count: summary.status_summary.rejected.count,
      amount: summary.status_summary.rejected.amount,
      colorClass: 'text-red-500',
    },
    {
      status: 'reimbursed',
      label: 'Reimbursed',
      count: summary.status_summary.reimbursed.count,
      amount: summary.status_summary.reimbursed.amount,
      colorClass: 'text-cyan-500',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
      {statusCards.map((card) => (
        <div key={card.status} className={`${cardClass} rounded-2xl p-5`}>
          <div className="flex items-center justify-between">
            <div>
              <div
                className={`text-xs font-medium ${isDark ? 'text-slate-400' : 'text-slate-600'}`}
              >
                {card.label}
              </div>
              <div className={`text-2xl font-bold mt-2 ${card.colorClass}`}>
                {formatCurrency(card.amount)}
              </div>
              <div
                className={`text-xs mt-1 ${isDark ? 'text-slate-500' : 'text-slate-500'}`}
              >
                {card.count} {card.count === 1 ? 'item' : 'items'}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ExpenseSummaryCards;
